import initializeValues from './initializeValues';
import openModal from './openModal';
import setIsNewRecord from './setIsNewRecord';

export default (values) => (dispatch) => {
    const newValues = {
        address: values.address,
        city: values.city,
        contact: values?.contact?.id,
        country: values.country,
        id: values.id,
        latitude: values.latitude,
        longitude: values.longitude,
        name: values.name,
        position: {
            latitude: values.latitude,
            longitude: values.longitude,
        },
        state: values.state,
    };
    dispatch(initializeValues(newValues));
    dispatch(setIsNewRecord(false));
    dispatch(openModal(true));
};
